import { ArrowDown, ArrowUp } from 'lucide-react'
import type { VmMetrics } from '@/api/types'
import { rate } from '@/ui/format'

// 초 단위 입출력 한 칸 — 네트워크(수신/송신) 또는 디스크(읽기/쓰기) 두 줄. 첫 읽기에는 속도가 없어 `—` 다.

export function IoLine({ metrics, kind }: { metrics: VmMetrics | undefined; kind: 'net' | 'disk' }) {
  const rows =
    kind === 'net'
      ? [
          { icon: <ArrowDown className="size-3" aria-hidden />, word: '수신', value: rate(metrics?.net_in) },
          { icon: <ArrowUp className="size-3" aria-hidden />, word: '송신', value: rate(metrics?.net_out) },
        ]
      : [
          { icon: null, word: '읽기', value: rate(metrics?.disk_read) },
          { icon: null, word: '쓰기', value: rate(metrics?.disk_write) },
        ]
  return (
    <div className="flex flex-col gap-1 text-[11px] tabular-nums text-muted-foreground">
      {rows.map((r) => (
        <span key={r.word} className="flex items-center gap-1">
          {r.icon ?? <span className="w-6">{r.word}</span>}
          {r.value}
        </span>
      ))}
    </div>
  )
}
